import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Mail, Check, AlertCircle, Clock } from "lucide-react";

const STATUS_ICON = {
  sent: { Icon: Check, color: "text-emerald-300" },
  mock: { Icon: Clock, color: "text-yellow-300" },
  error: { Icon: AlertCircle, color: "text-red-300" },
};

export default function AdminEmailLog() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/admin/email-log").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  return (
    <div>
      <h1 className="font-display font-extrabold text-4xl tracking-tighter text-white">Email Log</h1>
      <p className="mt-1 text-sm text-white/50">Last 100 outgoing emails (status updates + custom messages)</p>

      <div className="mt-4 p-4 rounded-md bg-yellow-500/10 border border-yellow-500/30 text-sm text-yellow-100">
        <strong>Heads up:</strong> Set <span className="font-mono">RESEND_API_KEY</span> in <span className="font-mono">/app/backend/.env</span> to actually deliver emails. Without it, emails are logged here as <span className="text-yellow-300 font-bold">MOCK</span> only.
      </div>

      <div className="mt-8 card-elev rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#0A0812] text-[10px] tracking-[0.22em] uppercase text-white/40 font-bold">
            <tr>
              <th className="text-left px-5 py-3">Status</th>
              <th className="text-left px-5 py-3">To</th>
              <th className="text-left px-5 py-3">Subject</th>
              <th className="text-left px-5 py-3">Sent</th>
            </tr>
          </thead>
          <tbody>
            {items.map((it) => {
              const meta = STATUS_ICON[it.status] || { Icon: Mail, color: "text-white/50" };
              return (
                <tr key={it.id} className="border-t border-white/5">
                  <td className="px-5 py-3">
                    <span className={`inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider ${meta.color}`}>
                      <meta.Icon size={12} /> {it.status}
                    </span>
                    {it.error && <div className="text-xs text-red-300/80 mt-1">{it.error}</div>}
                  </td>
                  <td className="px-5 py-3 text-white/80">{it.to}</td>
                  <td className="px-5 py-3 text-white">{it.subject}</td>
                  <td className="px-5 py-3 text-white/50 text-xs">{new Date(it.created_at).toLocaleString()}</td>
                </tr>
              );
            })}
            {items.length === 0 && <tr><td colSpan={4} className="px-5 py-10 text-center text-white/50">No emails yet</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
